import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { ENV } from 'configs';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault(ENV.TIMEZONE);
